export const REPORT_TYPE_IDS = {
  AIF001: 'AIF001',
  AIF002: 'AIF002'
};
